import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'
import React from 'react'

export default function DeleteRefillCell({ onClick }) {
  return (
    <Text textAlign="end" onClick={onClick} variant="bodyHyperLink">
      ELIMINAR
    </Text>
  )
}

DeleteRefillCell.propTypes = {
  clickValue: PropTypes.string,
  onClick: PropTypes.func,
}
